<template>
  <mi-dialog
    :model-value="changePmModal"
    :custom-design-dialog="true"
    class="send-to-search-change-pm-dialog"
    no-backdrop-dismiss
  >
    <div class="send-to-search-change-pm-dialog-wrapper">
      <div class="send-to-search-change-pm-header-wrapper">
        <div class="send-to-search-change-pm-btn">
          <h3 class="q-mt-none q-mb-none send-to-search-changePm-header"> Select a different product model </h3>
          <div class="send-to-search-changePm-close-icon">
            <mi-btn
              icon="close"
              icon-type
              icon-size="21px"
              fab
              flat
              @click="handleChangePmModal"
            ></mi-btn>
          </div>
        </div>

        <p class="q-mb-sm">
          The Product model that was on this collection has expired please select a new one.
        </p>
      </div>

      <div>
        <mi-td>
          <div class="change-pm-wrapper">
            <mi-select
              v-model="selectedProductModel"
              :options="productModels"
              :display-value="selectedProductModel.businessName || `${ selectedUserExport.businessName }`"
              :rules="productModelValidationRules"
              class="q-mb-sm select-pm-dropdown inspector-bottom-input"
              label="Product Model"
              option-label="businessName"
              options-selected-class="text-accent"
              outlined
              hide-bottom-space
            ></mi-select>
          </div>
        </mi-td>
      </div>

      <div class="send-to-search-change-pm-wrapper">
        <mi-btn flat @click="handleChangePmModal"> Cancel </mi-btn>
        <mi-btn @click="handleConfirm"> Confirm </mi-btn>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  import { ref } from 'vue'
  import { required } from '@/utils/validators'
  import { updateCollectionData } from '@/api/rest/saved-collections'

  export default {
    name: 'ChangePmConfirmation',
    props: {
      changePmModal: {
        type: Boolean,
        default: false
      },
      productModels: {
        type: Array,
        default: () => []
      },
      handleChangePmModal: {
        type: Function,
        default: () => {}
      },
      selectedUserExport: {
        type: Object,
        default: () => {}
      },
      successSendToSearchModalUserExport: {
        type: Function,
        default: () => {}
      }
    },
    emits: ['update:changePmModal', 'confirm'],
    setup(props) {
      const selectedProductModel = ref('')
      const productModelValidationRules = ref([required])

      const handleConfirm = async () => {
        const isValid = productModelValidationRules.value.every(rule => {
          const result = rule(selectedProductModel.value)
          return result === true
        })

        if (!isValid) {
          return
        }
        try {
          await updateCollectionData({
            collectionId: props.selectedUserExport.id,
            pmEncodedBusinessName: selectedProductModel.value.encodedBusinessName,
            options: props.selectedUserExport.options,
            components: props.selectedUserExport.components,
            planningPeriodRange: props.selectedUserExport.planningPeriod,
            productModelId: selectedProductModel.value.id
          })
        }
        catch (error) {
          console.error('Error updating collection:', error)
        }
        finally {
          props.successSendToSearchModalUserExport()
        }
      }
      return {
        handleConfirm,
        selectedProductModel,
        productModelValidationRules
      }
    }
  }
</script>

<style lang="scss" scoped>
  .send-to-search-change-pm-dialog {
    width: 475px;
    height: 280px;
  }

  .send-to-search-change-pm-header {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }

  .send-to-search-change-pm-close-icon {
    margin-top: -8px;
  }

  .send-to-search-change-pm-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
  // stylelint-disable declaration-no-important
  .send-to-search-change-pm-dialog-wrapper {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .send-to-search-change-pm-header-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .send-to-search-change-pm-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .send-to-search-confirmation-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .send-to-search-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
  }

  .change-pm-wrapper {
    width: 427px;
  }
</style>
